/**
 * Extract possible mcp tool name from the part.toolName
 *
 * Example toolNames are:
 * - dJIqnG7a_list_notion_databases
 * - dJIqnG7a_query_database_rows
 *
 * Where `dJIqnG7a` is the serverId and `list_notion_databases` is the name.
 **/
export function extractToolNameInformation(toolName: string) {
  const parsed = /^([a-zA-Z0-9_-]{8})_(.*)$/.exec(toolName);

  if (parsed) {
    const serverId = parsed[1];
    const name = parsed[2];
    return { serverId, name };
  }

  return {
    serverId: null,
    name: toolName,
  };
}
